import { render } from "./EditImmigration.vue?vue&type=template&id=5b43d68e"
import script from "./EditImmigration.vue?vue&type=script&lang=js"
export * from "./EditImmigration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__